import { useMutation, useQueryClient } from "@tanstack/react-query";
import galleriesMediaAPI from "../../api/galleries-media/api";

export function useCreateGalleryMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: galleriesMediaAPI.createGalleryMedia,
    onSuccess: (data, variables) => {
      // Invalidate and refetch galleries media list
      queryClient.invalidateQueries({ queryKey: ["galleries-media"] });

      // If the media has a galleryId, invalidate that specific gallery's media
      if (variables.galleryId) {
        queryClient.invalidateQueries({
          queryKey: ["galleries-media", "gallery", variables.galleryId],
        });
      }
    },
    onError: (error) => {
      console.error("Create gallery media failed:", error);
    },
  });
}
